export const bodyFont = `'Raleway', Arial, sans-serif`;
export const headerFont = `'Carter One', Arial, sans-serif`;
